import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {paypalDescription, type PayPalGateway} from './paypal';
import paypalBadgeURL from '../../../img/badge/paypal.svg';
import paypalPaylaterImageURL from '../../../img/marks/paypal-paylater.svg';
import {type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../../@type/features';
import {Feature} from '../../reducers/environmentReducer';
import {PayPalPaymentButton} from './class-paypal-payment';
import {render} from '../../reducers/rootReducer';
import {store} from '../../store';

function initPayPalPayLaterMethod(): PayPalGateway {
	let buttonInstance: PayPalPaymentButton | null = null;

	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.PAYPAL_PAYLATER_GATEWAY, 'title') ?? 'PayPal Pay Later',
		gatewayId: 'peachpay_paypal_paylater',
		description: paypalDescription('PayPal Pay Later', paypalPaylaterImageURL, 'After selecting the PayPal Pay Later button you will be prompted to complete your payment.'),
		assets: {
			badge: {src: paypalBadgeURL},
			title: {src: paypalPaylaterImageURL},
		},
	};

	return {
		config,
		activate(paypal, orderService) {
			buttonInstance = new PayPalPaymentButton(paypal, orderService, {
				gatewayId: 'peachpay_paypal_paylater',
				fundingType: 'paylater',
				buttonStyle: Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_PAYLATER_GATEWAY, 'button_style') ?? undefined,
			});
			config.initialized = buttonInstance.isEligible();
			store.dispatch(render());
		},
		reset() {
			buttonInstance?.unmount();
			buttonInstance = null;
			config.initialized = false;
			store.dispatch(render());
		},
		attach(selector) {
			buttonInstance?.mount(selector);
		},
		detach() {
			buttonInstance?.unmount();
		},
	};
}

export {
	initPayPalPayLaterMethod,
};
